import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {EnvironmentService} from "@shared/api";
import {UnitsEnum} from "@shared/enum";

export type MenuDeviceNodesDto = MenuDeviceNode[];
export type MenuDeviceMetricNodesDto = MenuDeviceMetricNode[];

interface MenuDeviceNode {
    id: string;
    name: string;
    nodes: MenuDeviceNode[];
}

interface MenuDeviceMetricNode extends MenuDeviceNode {
    metrics: Metric[];
    analytical_metrics: AnalyticalMetric[];
    nodes: MenuDeviceMetricNode[];
}

type AnalyticalMetric = Metric;

interface Metric {
    id: string;
    unit: keyof typeof UnitsEnum;
    local_name: string;
}

interface Settings {
    min: number | null;
    max: number | null;
}

@Injectable({providedIn: "root"})
export class WidgetConstructorService {
    private http = inject(HttpClient);
    private env = inject(EnvironmentService);

    private menuNodesUrl = this.env.apiUrlV2 + "/dashboard/constructor/nodes";
    private metricsUrl = this.env.apiUrlV2 + "/dashboard/constructor/metrics/";
    private devicesPath = "/devices";
    private metricsPath = "/metrics";

    getDeviceNodes(stationId: string): Observable<MenuDeviceNodesDto> {
        return this.getDeviceStationNodes(stationId);
    }

    getDeviceMetricNodes(stationId: string): Observable<MenuDeviceMetricNodesDto> {
        return this.getDeviceStationMetricNodes(stationId);
    }

    getDeviceStations(): Observable<MenuDeviceNodesDto> {
        return this.getDeviceStationNodes();
    }

    getDeviceMetricStations(): Observable<MenuDeviceMetricNodesDto> {
        return this.getDeviceStationMetricNodes();
    }

    getDatasetSettings(datasetId: string) {
        return this.http.get<Settings>(this.createSettingsUrl(datasetId));
    }

    private getDeviceStationNodes(stationId?: string): Observable<MenuDeviceNodesDto> {
        return this.http.get<MenuDeviceNodesDto>(this.menuNodesUrl + this.devicesPath, {
            params: stationId ? {station_id: stationId} : undefined
        });
    }

    private getDeviceStationMetricNodes(stationId?: string): Observable<MenuDeviceMetricNodesDto> {
        return this.http.get<MenuDeviceMetricNodesDto>(this.menuNodesUrl + this.metricsPath, {
            params: stationId ? {station_id: stationId} : undefined
        });
    }

    private createSettingsUrl(datasetId: string) {
        return this.metricsUrl + datasetId + "/settings";
    }
}
